module.exports = __webpack_public_path__ + "static/media/PSLxTextBoldItalic.b88ba8f0.ttf";